import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioService, UsuariosService } from '../../servicios/index.service';
declare var $;
declare var tabla_registro;

@Component({
  selector: 'app-registro',
  templateUrl: 'registro.component.html',
})
export class RegistroComponent implements OnInit {

  id:any;
  registros:any;
  data_registros:any;
  gif:boolean = true;

  constructor( private route: ActivatedRoute, private router:Router,
              private _usuarios:UsuariosService, private _servicio: ServicioService  ) {
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';

    this.route.params.subscribe( params=>{
          this.id = params['id'];
          if( this.id == undefined ){
            this.router.navigate(['/home']);
          }
        } );
  }

  ngOnInit() {
    $(document).ready(function() {
      $("body").css("overflow","auto");
    });
    this.carga_datos();

  }

  ngOnDestroy(){
    this.registros.unsubscribe();
  }

  carga_datos(){

      this.registros = this._usuarios.consult_registro(this.id).subscribe(data=>{
        this.data_registros = data;
        if(this.data_registros){
          this.settime();
          console.log("Se cargo");
          this.gif = false;
          if( typeof tabla_registro !== 'function' ){
          }

          this.registros.unsubscribe();
        }else{
          alert("Error al cargar datos");
        }
      });
  }

  settime(){
    setTimeout(function(){
      function tabla_registro() {
        $("#example1").DataTable();
        $('#example2').DataTable({
          "paging": true,
          "lengthChange": false,
          "searching": false,
          "ordering": true,
          "info": true,
          "autoWidth": false,
          "order": [[ 5, 'desc']]
        });
      }
      tabla_registro();
    },1500);
  }

  boorarHistorial(){
    let txt;
    let r = confirm("Los registros de este usuario serán borrados por completo. ¿Realmente quieres borrarlos?");
    if (r == true) {
        this._servicio.borrarHistorial(this.id).subscribe(data=>{
          if(data == null){
            this.notificacion("Los registros se borraron correctamente", "primary");
          }else{
            this.notificacion("Ocurrió un error al borrar los registros", "danger");
          }
        });
    } else {
        this.notificacion("La eliminación de registros fue cancelada", "warning");
    }
  }

  notificacion(text:string, tipo:string){
    if( tipo == "primary" ){
      $.notify({
        icon: 'fa fa-history',
        title:"<b>Registros</b><br>",
        message:text
      },{
        timer: 10000
      });
    }else{
      $.notify({
        icon: 'fa fa-history',
        title:"<b>Registros</b><br>",
        message:text
      },{
        timer: 10000,
        type:tipo
      });
    }
  }
  regresa(){
    this.router.navigate(["/usuarios"]);
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/registro/registro.component.ts